import { Component, OnInit } from "@angular/core";
import { ProgramEditorService } from "../../program-editor.service";
import { Subscription } from "rxjs/Subscription";
import { Program, ProgramServices } from "@models/program";

@Component({
    templateUrl: "./program-services-review.component.html"
})

export class ProgramServicesReviewComponent implements OnInit {
    public model: ProgramServices;
    public dataReadySub: Subscription;

    public communitySchoolsTooltip: string = Program.communitySchoolsTooltip;

    constructor(private editorService: ProgramEditorService) { }

    ngOnInit(): void {
        this.getData();
    }

    getData(): void {
        let ready = this.editorService.compareDataReady;
        if (ready) {
            let program = this.editorService.compareData;
            if (program.services == undefined) {
                this.model = new ProgramServices();
            } else {
                this.model = program.services;
            }

            if (this.dataReadySub != undefined) {
                this.dataReadySub.unsubscribe();
            }
        } else {
            this.dataReadySub = this.editorService.compareDataReady$.subscribe(x => this.getData());
        }
    }

}



// WEBPACK FOOTER //
// C:/WORK/Projects/ActNow_NG2/src/app/common/program-editors/review/services/program-services-review.component.ts